import {CUSTOM_ELEMENTS_SCHEMA, NgModule, isDevMode, ModuleWithProviders} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {OAuthModule} from 'angular-oauth2-oidc';
import {FmcElementsComponent} from './fmc-elements.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSelectModule} from '@angular/material/select';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {LookupService} from './services/lookup.service';
import {HttpErrorHandlerService} from './services/http-error-handling.service';
import {FormBuilderService} from './services/form-builder.service';
import {BsbSearchDialogComponent} from './bsb-search/bsb-search.component';
import {CreditProviderSearchComponent} from './credit-provider-search/credit-provider-search.component';
import {TypesService} from './services/types.service';
import {ClientService} from './services/client.service';
import {HistoryService} from './services/history.service';
import {CommunicationsService} from './services/communications.service';
import {ChatComponent} from './chat/chat.component';
import {JobsService} from './services/jobs.service';
import {CustomEnvironment} from '../environments/environment';
import {PdfToolsModule} from './pdf-tools/pdf-tools.module';
import {FilesService} from './services/files.service';
import {PdfToolsService} from './services/pdf-tools.service';
import {CollateralService} from './services/collateral.service';
import {FmcLibraryNotificationService} from './services/notification.service';
import {CalendarService} from './services/calendar.service';
import {CreditCardDirectivesModule, CreditCardFormatDirective} from 'angular-cc-library';
import {PaymentService} from './services/payment.service';
import {SalesService} from './services/sales.service';
import {VxCoreService} from './services/vx-core.service';
import {ValexSearchComponent} from './valex-search/valex-search.component';
import {CsvService} from './services/csv.service';
import {SettlementsService} from './services/settlements.service';
import {TypeTextBySlug} from './pipes/type-text-by-slug.pipe';
import {BankingService} from './services/banking.service';
import {environment} from '../environments/environment';
import {DialogConfirmationComponent} from './dialog-confirm/dialog-confirm.component';
import {DateRangeComponent} from './date-range/date-range.component';
import {AngularEditorModule} from '@kolkov/angular-editor';
import {AppointmentTitle} from './appointment/appointment.pipe';
import {AsyncPipe, NgFor, NgIf} from '@angular/common';
import {PhoneDialogComponent} from './phone-dialog/phone-dialog.component';
import {SmsDialogComponent} from './sms-dialog/sms-dialog.component';
import {EmailDialogComponent} from './email-dialog/email-dialog.component';
import {CommsMessageDialogComponent} from './comms-message-dialog/comms-message-dialog.component';
import {UnattendedDialogComponent} from './unattended-dialog/unattended-dialog.component';
import {TreeService} from './services/tree.service';

@NgModule({
  declarations: [
    FmcElementsComponent,
    BsbSearchDialogComponent,
    CreditProviderSearchComponent,
    ChatComponent,
    ValexSearchComponent,
    TypeTextBySlug,
    DialogConfirmationComponent,
    DateRangeComponent,
    UnattendedDialogComponent
  ],
  exports: [
    MatFormFieldModule,
    MatCardModule,
    MatListModule,
    MatInputModule,
    MatExpansionModule,
    MatTableModule,
    MatChipsModule,
    MatSelectModule,
    MatDialogModule,
    MatButtonModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatDatepickerModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatMenuModule,
    MatButtonToggleModule,
    MatTooltipModule,
    PdfToolsModule,
    FmcElementsComponent,
    BsbSearchDialogComponent,
    CreditProviderSearchComponent,
    ChatComponent,
    ValexSearchComponent,
    TypeTextBySlug,
    DialogConfirmationComponent,
    DateRangeComponent,
    AngularEditorModule,
    AppointmentTitle,
    CommsMessageDialogComponent,
    UnattendedDialogComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ], imports: [FormsModule,
    ReactiveFormsModule,
    OAuthModule.forRoot(),
    MatFormFieldModule,
    MatCardModule,
    MatListModule,
    MatInputModule,
    MatExpansionModule,
    MatTableModule,
    MatChipsModule,
    MatSelectModule,
    MatDialogModule,
    MatButtonModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatDatepickerModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatMenuModule,
    MatButtonToggleModule,
    MatTooltipModule,
    PdfToolsModule,
    CreditCardDirectivesModule,
    AngularEditorModule,
    AppointmentTitle,
    NgIf,
    NgFor,
    AsyncPipe,
    PhoneDialogComponent,
    SmsDialogComponent,
    EmailDialogComponent,
    CommsMessageDialogComponent], providers: [
    HttpErrorHandlerService,
    LookupService,
    FormBuilderService,
    TypesService,
    ClientService,
    HistoryService,
    CommunicationsService,
    JobsService,
    FilesService,
    PdfToolsService,
    CollateralService,
    FmcLibraryNotificationService,
    CalendarService,
    PaymentService,
    SalesService,
    VxCoreService,
    CsvService,
    SettlementsService,
    BankingService,
    TreeService,
    CreditCardFormatDirective,
    provideHttpClient(withInterceptorsFromDi())
  ]
})

export class FmcElementsModule {
  // allow passing of environment variables
  static forRoot(environment): ModuleWithProviders<FmcElementsModule> {
    return {
      providers: [
        {provide: CustomEnvironment, useValue: environment}
      ],
      ngModule: FmcElementsModule
    };
  }

  constructor() {
    console.log('initializing FMC Elements Module');
    // if (isDevMode()) {
    //   setEnvironmentToProd();
    // }
    console.log('ENV', environment);
  }
}
